import { Component, Input, AfterViewInit, OnInit, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";

declare var $: any;
declare var echarts: any;

@Component({
	selector: 'app-audio-play',
	templateUrl: './app-audio-play-base.component.html',
	styleUrls: ['./app-audio-play-base.component.css']
})
export class AppAudioPlayBaseComponent implements OnInit, AfterViewInit {
  @HostListener('window:popstate', ['$event']) onPopState() {
    if(this.audioObj) {
      this.audioObj.pause();
    }
  }
  @Input() audioList: any;
  //当前播放信息
  currentAudio: any;
  //当前播放对象
  audioObj: any;
  //当前播放索引
  currentIndex: number = 0;
  //播放进度
  audioProcess: number = 0;
  //显示播放时长
  audioProcessTimes: string = "0:00/0:00";
  //播放状态
  playStatus: boolean = false;
  //第一次播放
  firstPlay: boolean = true;
  //是否显示 tool bar
  showToolBar: boolean = false;
  //当前显示模式
  showTextModel: string = "day";
  //弹窗提示
  showTipEnable: boolean = false;
  //显示加载提示
  showLoading:boolean = false;
  //报告信息
  report: any;
  learningPathMetaId : string
  surveyMetaId: number;
  surveyId: number;
  learningPathOrLearningTourId: number;
  method: number;
  assetsRoute: string = "../../assets";
  constructor(private commonService: CommonService,
              private apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router,
              private el: ElementRef) {}

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.route.params.subscribe(params => {
      this.learningPathMetaId = params['learningPathId']
      this.surveyMetaId = params['surveyMetaId'];
      this.learningPathOrLearningTourId = params['learningPathOrLearningTourId'];
      this.method = params['method'];
      this.surveyId = params['surveyId'];
      this.currentIndex = params['audioIndex'];
    });

    this.getAudioListInfo().subscribe(result => {
      result = [{"unitId":1,"name":"领导力，和个性有关吗？","totalTime":371,"audioUrl":"assets/audio/unit1.mp3","audioImg":"/audioimg/audioimg1","audioContent":"<div>主讲专家介绍：</div><br/><div class=\"audio-special\">李慧渊 <br>Huiyuan Li <br>DDI大中华区TDS总经理 <br><br><img class=\"audio-special-img\" src=\"assets/picture/audioplay/report/lihuiyuan.png\" /><div>多年来投身于设计并执行组织人才战略的规划、人才评鉴与发展、高管教练、高潜人才遴选等项目。目前领导DDI的创新业务模块，将总部的最新研发成果引入中国市场，并研发适合中国市场的产品。</div><br><div>擅长领域：不同层级人才评鉴和发展项目设计和实施，利用评鉴技术和领导力发展手段协助领导者增进自我认知，发展能力，提升业务成效。</div> <br></div><div>语音稿：</div><br/><p>你好，我是慧渊，目前负责DDI（智睿咨询）大中华的咨询业务和产品研发。在过去这十几年里面，我专注于领导力，做过很多的高管评估、反馈和辅导。</p><p>我们今天来谈一谈个性和领导力之间的关系，来解读您的领导力DNA测验报告。</p><p>在我这些年的咨询生涯中，常常会有人问我：我很内向，是不是不适合做领导者？我和直属上司的个性非常不一样，是不是意味着未来的合作会很困难？我跟某些人相处非常愉快，但与另一些人却完全无法合作，这到底是我的问题，还是别人的问题？</p><p>《基业长青》（Built to last）的作者吉姆·柯林斯（James Collins）曾把领导力分为五级，其中最高等级的“第五级领导者”，是能够通过将个人谦逊性格与职业意志进行复杂结合，从而建立企业长期持续发展力的人。人们通常因为“第五级领导者”一定要具有领导魅力和卓越非凡的英雄气质。但是柯林斯却认为，真正的第五级领导者，很有可能是那些不爱出现在公众场合、不善言辞的人，他们会呈现出复杂甚至带点冲突的人格特征——“谦逊而执着、腼腆而无畏”，平时平静如水，却在关键时刻勇于决断，敢于承担。</p><p>相信大家也见过很多这样的公众人物，所以领导者到底应该是“低调、害羞和含蓄”，还是“外向、张扬和激进”，相信每个人在心里都有自己的见解。不管结论是什么，相信大家都一致认同，个性对于职业和领导者的重要性。</p><p>在我们的职业生涯当中，一定也发现有些领导者走到了更高的管理岗位后，无法去好地激励团队，或者有些领导者无法与伙伴建立良好的工作关系，再有一些领导者缺乏远景和大局观，过于细节导向。</p><p>那么说到这里，到底什么是个性？在心理学里面个性其实分为两个视角：内部视角和外部视角。内部视角其实就是我们的自我认知——你如何看待你自己。这基于个人意愿，反映个人的价值观，而“内部视角”是很难被度量和研究的。人们常常会高估自己的幽默感、人际交往能力、领导能力或者判断能力，这些自我认知并不总是能够在行为当中展现出来的。</p><p>那么第二个视角“外部视角”，也就是别人如何看待你，你的“声望”(reputation)如何，往往是可以用行为特征来定义和描述的。举个例子来讲，冷静、羞涩、自信，这些都是我们描述别人的常用词汇。因为它们是在与他人频繁的互动过程当中可以被观察到的。所以可以用来反映他人是如何评价你的行为的。同时一个人的行为特征能用来预测他（她）在新环境中的行为，从而预测他的工作绩效。所以相比内部视角，外部视角所展现的行为特征更容易被研究和度量。</p><p>举个例子来讲，有领导者可能非常关注细节，他（她）对所有的环节都要有充分的把握。那他（她）们对自己的评估可能是“我这个人比较稳妥”。但在工作当中，他（她）的伙伴可能会觉得这位领导者过于关注细节，所以伙伴会对他（她）的评价是：“很龟毛”。同样的特质，内部视角和外部视角就不一样。所以通常情况下自我认知的程度，取决于一个人对自己的评估与别人对他（她）的评估之间的差距。如果外部视角和内部视角的一致程度越高，就意味着这个人的自我认知水平越高。大部分情况下，自我评估与他人评价会有很大程度是重叠的，大概是在80~85%之间。</p><p>那么一定有人想问了，既然是这样，如何能够更好地了解提升我的自我认知程度？其实，真相有三个维度组成。第一个是你对自己的评价；第二个是在工作当中、生活当中，他人对你的观察和评估；第三，就是像“领导力DNA”这样的客观评估——它更多的是在你的人生中截取一个横截面，集中地了解你的行为模式，并且给出客观的评估。所以想要更好地提升自我认知，了解自己，其实是更好地了解来自三个方向（自我认知、他人的观察和评估以及客观评估）的不同信息，并做出有效整合。</p><div class=\"audio-img-wrap\"><img src=\"assets/picture/audioplay/report/107.png\"/><div class=\"audio-img-title\">自我“真相”的三个维度</div>","lastUnitIdFlag":true,"currentTime":3},{"unitId":2,"name":"五个指标，就能测出个性吗？","totalTime":204,"audioUrl":"assets/audio/unit2.mp3","audioImg":"/audioimg/audioimg2","audioContent":"<p>上节课我们讲了“个性是什么”。此时，你心里可能会有个问题：领导力DNA测评的五个指标，真的能完整地测出我的个性吗？</p><p>我们先来看一看个性指标的起源。</p><p>在几乎所有的语言中都有很多描述人类个性的词汇。最早，英国的科学家高尔顿爵士希望弄出一本“靠谱”的词典，将这些个性词汇进行归类。根据高尔顿的方法，1936年美国心理学家阿尔波特和奥德伯特整理了一份史无前例的人格词表，总共包含17953个英文单词。到上个世纪40年代，美国心理学家卡特尔采用聚类分析和因素分析的方法，又大幅地缩减了个人特质的数量。在那之后，美国心理学家托普斯和克里斯托分别分析了八个不同的人格测评结果，分析提取出五个相同的个性因素，当他们看到只有五个因素的时候也惊呆了。</p><p>到了1981年，美国心理学家戈尔德伯格给这五个因素命名为“大五”（Big Five）。“大五”是目前心理学界公认的最为常用的人格因素，分别是：外向、开放、严谨、亲和和情绪稳定。</p><div class=\"audio-img-wrap\"><img src=\"assets/picture/audioplay/report/105.png\"/><div class=\"audio-img-title\">“大五”指标说明</div>\n</div><p>那么，个性和领导者角色到底是什么关系呢？简单来说，个性是我们履行不同的职务角色时的助力和阻力。</p><p>同样的个性，在某一个角色上可能是助力。但在另外一个角色上，可能就是阻力。举个例子来讲，有的人很关注细节，如果你要做的是协助企业执行流程，提升流程效率，那么“关注细节”、“务实”就是你个性上的助力；可是如果你的工作任务是要去协助企业培养人才，甚至制定培养人才战略，这时候这个人更需要有大局观，所以过分掌控细节、掌控他人，可能会成为职务角色的阻力。</p><p>正是因为个性具有适配度，所以我们会发现，在企业中，从个人贡献者晋升为管理者时，很多人会出现转型挑战。</p><p>举个例子来讲，当我只是个人贡献者的时候，我只需要自己完成任务；但是当我成了管理者时，我需要影响和调动别人一起工作，需要不断地提升下属的能力，让他们能够更加胜任工作。同时也要安排好自己和团队的时间，调配好资源。那这一些都是个人贡献者，转型成为领导者，是最常见的转型挑战。</p><p>总结一下，个性对于领导者角色非常重要，也会影响我们履行工作职责；在我们转型过程中，个性有可能会协助我们做好转型，也有可能成为我们的阻碍。</p>","lastUnitIdFlag":false,"currentTime":0},{"unitId":3,"name":"指标解读，认识你的领导力DNA","totalTime":280,"audioUrl":"assets/audio/unit3.mp3","audioImg":"/audioimg/audioimg3","audioContent":"<p>这节课，我们来看看五个指标怎么解读。</p><p>五个指标的结果：65分以上为高分区，35分以下为低分区，35分~65分为中间分。</p><p>第一个指标：外向，衡量的是一个人对人际互动和社会认同的需求程度。高分的人一般喜欢交际和构建人际网络。他们行为的主要动力来源于别人的认可和关注。比起做追随者，他们更希望领导别人，与别人互动是他们能量的来源。低分的人更倾向于沉默寡言，他们交朋友更注重质量而不是数量。他们行为的主要动力来源于自我认可，而不是他人认可。 他们的领导意愿通常会比较弱，与别人互动会让他们损耗能量，反之，独处可以让他们获得能量。</p><p>第二个指标：亲和，衡量的是一个人愿意关心并理解别人感受的倾向。高分的人一般喜欢觉察，喜欢主动解读别人的情绪，他们更希望得到认可，希望做出能够让大多数人认可的决策，非常重视团队合作。低分的人更加问题导向，他们倾向于直指问题的症结，较少在意别人的感受，他们更重视效率和问题的实际解决，非常享受独立工作。</p><p>第三个指标：开放，衡量的是一个人对新事物的态度。通常高分的人倾向于主动关注新事物、新趋势、新技术，他们渴望学习新东西，并且密切关注未来的可能性。而低分的人更愿意接受比较熟悉的事物，更习惯采用原有的方式解决问题，同时也会非常关注当下工作的执行和细节。</p><p>第四个指标：严谨，衡量的是一个人愿意遵守规范，为达成目标而努力的程度。高分的人更愿意按照规则行事，他们往往需要更加清晰的职责分工，有很强的计划性，也会自我约束，通常他们会竭尽所能地实现既定目标。低分的人倾向于把变化和不确定性视为机遇，他们擅长灵活地运用规则，并且会随时调整计划。</p><p>第五个指标：情绪稳定，衡量的是一个人对情绪的体验和对情感调节的水平。高分的人，他们更善于调节情绪，他们的行为不容易受到情绪的影响，即使是在高压下，他们仍然能够保持高效行事，他们很少会感受到焦虑和紧迫性。低分的人往往给人感觉情绪起伏比较大，行为比较容易受到情绪的影响，他们需要别人时常给予支持和鼓励，并且自己也常常会产生焦虑和紧迫感。</p><p>听到这里，有些人可能会觉得你的部分指标和你的自我认知不完全一致。为什么呢？</p><p>还记得我们刚开始讲到的个性的“两个视角”吗？报告在这里呈现的是外部视角，也就是“别人眼中的你”。如果你的内在我和外在我差异很大，建议你也先不要急着否定，愉快地接纳自己，同时关注整体的结果，而不是单个的特质，避免断章取义。另外向那些了解你的人收集反馈，以及思考你的某些特质可能会带给别人的影响，也将有助于你全面地了解你的结果。</p><p>总结一下，我们介绍了外向、亲和、开放、严谨和情绪稳定这五个不同的个性特质。 下个单元，我们会分享这五个特质组合在一起所带给我们的新洞察。</p>","lastUnitIdFlag":false,"currentTime":0},{"unitId":4,"name":"DNA组合，带来更多洞察","totalTime":332,"audioUrl":"assets/audio/unit4.mp3","audioImg":"/audioimg/audioimg4","audioContent":"<p>上节课我们讲到了单个个性指标的内涵。</p><p>在过去给高管做反馈和辅导时，也常常有高管问我：我的某些个性指标分数很低，是不是需要特别注意？我的低分很多，是不是不太适合做领导者？事实上，每个人都会有高分项和低分项。我们还是先来看一看，这些指标组合在一起意味着什么。</p><div class=\"audio-img-wrap\"><img src=\"assets/picture/audioplay/report/101.png\"/><div class=\"audio-img-title\">案例一</div>\n</div><p>第一个案例（见上图）：“外向”和“开放”得分很高，“情绪稳定”、“亲和”和“严谨”得分低。这样的人通常在工作当中喜欢通过交朋友来达成工作目标，同时对新的人和新的事物都保持好奇心和开放态度，较低的情绪稳定性又让他（她）能够时刻保持工作激情。 他（她）很适合做销售。</p><div class=\"audio-img-wrap\"><img src=\"assets/picture/audioplay/report/102.png\"/><div class=\"audio-img-title\">案例二</div>\n</div><p>不过，并不是所有的销售都是这个类型。举个例子（见上图：案例二），我也见过情绪稳定性很高，开放性也高的人成为优秀的销售。但是他（她）往往可能是技术型销售，因为“情绪稳定”的高分能让人感受到冷静和镇定，在面对压力的时候，能够比别人表现出更加镇定。适当的“开放”也能够让他积极接受新的事物。</p><div class=\"audio-img-wrap\"><img src=\"assets/picture/audioplay/report/103.png\"/><div class=\"audio-img-title\">案例三</div>\n</div><p>第三个案例：“情绪稳定”很高，“严谨”也很高。其他三项“亲和”、“外向”和“”开放相对低分”。这样的人会非常关注细节，喜欢在执行当中钻研细节，并且做到完美，同时给人的印象是非常冷静镇定，即使在面对复杂问题和困难的时候，也能够保持这样的态度。这是一个典型的研发人员的个性特质。</p><div class=\"audio-img-wrap\"><img src=\"assets/picture/audioplay/report/104.png\"/><div class=\"audio-img-title\">案例四</div>\n</div><p>最后一个案例：“亲和”、“严谨”和“开放”中等，“情绪稳定”、“外向”属于低分。大家可以猜一猜，这样的人适合做什么样的岗位？事实上，中等的亲和、严谨和开放，让人能够在工作当中比较平衡地处理人和事物。同事对新的工作内容和新的人事也能够保持一定的开放度。但是在工作当中，他可能不太喜欢跟人打交道，更多关注自己的工作任务。这其实是一个后台部门的人员。</p><p>讲完个性组合，我们再来看一看个性和能力之间的关系。</p><div class=\"audio-img-wrap\"><img src=\"assets/picture/audioplay/report/106.png\"/><div class=\"audio-img-title\">个性与能力</div>\n</div><p>一个人的个性特质比较像是硬件，相对难以改变。而你的能力更像是行为技巧，如同软件比较容易被培养和发展。个性更多的是被管理，即使它很难被发展，很难做改变。比如有些人可能很关注细节，当他在中层管理岗位上的时候能够很好地展现这个优势，但是再往上发展，他必须要更关注战略层面，这个时候他很难强迫自己走到另一个极端——完全不关注细节，但是他可以适当地减少自己对细节的管控。</p><p>而能力，因为是软件，所以可以被发展。在发展过程中，有些个性会成为助力，能够帮助你更快的发展这项能力。如果你的个性很外向和开放，当你需要辅导授权下属的时候，你会比那些内向或开放性不高的领导者更加自如；相应地，也会有些个性阻碍你的领导力发展。比如，如果你的“亲和”得分很高，当面对复杂的人事决策时，你可能会显得很纠结，无法当机立断。</p><p>经过上面的解读，不知道你对自己的“领导力DNA报告”有了更好的了解吗？不同的个性在领导力的发展过程实发挥了不同的作用。鼓励你在课后思考一下，如何更好地运用个性特质规划你的领导力发展。</p><p>最后我们来谈一谈个性和学习成效的关系。巴菲特说过，“在能力圈内行动，在舒适圈外学习”。培训要走出舒适圈，但执行要回到能力圈。那么，你的个性是否会影响学习呢？研究发现，是有的。我们发现某些个性特质会影响个人的学习方式和学习成效。比如，我们发现高严谨、低开放的人，学习成效往往不那么明显。究其原因，可能是这样的人更倾向于关注细节，更喜欢接受熟悉的事物。相比高开放、低严谨的人，他们需要更多的时间内化知识点和学习元素。</p><p>接下来你即将进入英跃的学习旅程，建议你关注自己的个性特质在接下来的学习旅程中对你学习风格，学习方式和学习效果会产生的影响，让你的学习成效最大化。</p>","lastUnitIdFlag":false,"currentTime":0}]
      this.audioList = result;
      if(this.audioList.length > 0) {
        this.currentAudio = this.audioList[this.currentIndex];
        setTimeout(() => {
          this.audioInit();
          // this.audioObj.src = this.currentAudio.audioUrl;
        }, 300);
      }

    });

    this.getReport();
  }

  audioInit() {
    this.audioObj = this.el.nativeElement.querySelector("audio");
  }

  ngAfterViewInit() {
    this.commonService.initPage();
  }
  //播放音频
  playAudio() {
    if(!this.playStatus) {
      this.audioObj.play();
      let obj={
        'learningPathMetaId':this.learningPathMetaId,
        'btnName' :'能力考核音频',
        'module' : "4",
        'courseUnit' :"",
        'type' : 0,
        'userId' : localStorage.getItem("userId")
      }
      this.apiService.learingTime(obj).subscribe()
    } else {
      this.audioObj.pause();
    }
  }
  /* 播放进度 */
  timeupdate() {
    if(this.touchEnable) {
      return false;
    }
    let currentaudio = this.audioObj;
    if(currentaudio){
      if(!currentaudio.duration) {
        return false;
      }
      let audioAllTime = currentaudio.duration;
      this.updateProcessUI(currentaudio.currentTime, audioAllTime);
    }
    
  }
  updateProcessUI(currentTime, AllTimes) {
    this.audioProcess = currentTime * 100 / AllTimes;
    this.audioProcessTimes = this.getTimeformat(currentTime) + "/" + this.getTimeformat(AllTimes);
  }
  /* 进度直接移到当前播放位置 */
  moveCurrentTimes() {
    if(this.audioObj){
      if(!this.audioObj.duration) {
        return false;
      }
      this.audioObj.currentTime =this.currentAudio? this.currentAudio.currentTime : "";
      this.updateProcessUI(this.audioObj.currentTime, this.audioObj.duration);
    }
  }
  /* 播放事件 */
  play() {
    this.playStatus = true;
  }
  /* 暂停事件 */
  pause() {
    this.playStatus = false;
    this.showLoading = false;
  }
  /* 播放完毕 */
  ended() {
    this.showLoading = false;
    this.playStatus = false;
    this.currentAudio.currentTime = 0;
    //播放下一条
    this.playNext();
  }
  /* 正常播放 */
  canplaythrough(){
    this.showLoading = false;
  }
  /* 加载音频中... */
  warting(){
    this.showLoading = false;
  }
  /* 元数据加载完成 */
  loadeddata() {
    this.timeupdate();
    this.moveCurrentTimes();
    if(!this.firstPlay) {
      this.audioObj.play();
    }
  }
  /* 前进 */
  forward() {
    if(!this.playStatus) {
      return false;
    }
    if(this.audioObj.currentTime + 15 >= this.audioObj.duration) {
      this.audioObj.currentTime = this.audioObj.duration;
    } else {
      this.audioObj.currentTime = this.audioObj.currentTime + 15;
    }
  }
  /* 后退 */
  fallback() {
    if(!this.playStatus) {
      return false;
    }
    if(this.audioObj.currentTime - 15 < 0) {
      this.audioObj.currentTime = 0;
    } else {
      this.audioObj.currentTime = this.audioObj.currentTime - 15;
    }
  }
  /* 下一个 */
  playNext() {
    if(this.currentIndex < this.audioList.length - 1) {
      this.audioObj.pause();
      this.currentIndex++;
      this.currentAudio.currentTime = 0;
      this.currentAudio = this.audioList[this.currentIndex];
      this.audioObj.src = this.currentAudio.audioUrl;
      this.audioObj.play();
      this.saveUserAudioProcess(0, null);
    }
  }
  /* 上一个 */
  playPre() {
    if(this.currentIndex > 0) {
      this.audioObj.pause();
      this.currentIndex--;
      this.currentAudio.currentTime = 0;
      this.currentAudio = this.audioList[this.currentIndex];
      this.audioObj.src = this.currentAudio.audioUrl;
      this.audioObj.play();
      this.saveUserAudioProcess(0, null);
    }
  }
  getTimeformat(timeSeconds) {
    var theTime = timeSeconds; // 秒
    var theTime1 = 0; // 分
    var theTime2 = 0; // 小时
    if(theTime > 60) {
      theTime1 = Math.floor(theTime / 60);
      theTime = Math.floor(theTime % 60);
      if(theTime1 > 60) {
        theTime2 = Math.floor(theTime1 / 60);
        theTime1 = Math.floor(theTime1 % 60);
      }
    }
    var result = "" + Math.floor(theTime);
    if(theTime < 10) {
      result = "0" + result;
    }
    if(theTime1 > 0) {
      result = "" + Math.floor(theTime1) + ":" + result;
    } else {
      result = "0:" + result;
    }
    if(theTime2 > 0) {
      result = "" + Math.floor(theTime2) + ":" + result;
    }
    return result;
  }
  /* 获取播放列表 */
  getAudioListInfo() {
    return this.apiService.ajax({
      "type": "get",
      "url": 'sr/coursedna/queryCourseDNAList'
    });
  }
  /* 保存用户播进度 */
  saveUserAudioProcess(currentTime, callback) {
    this.apiService.ajax({
      "type": "post",
      "url": 'sr/coursedna/saveDNAUserAudioRecord/' + this.currentAudio.unitId + '/' + Math.floor(currentTime)
    }).subscribe(() => {
      if(callback) {
        callback();
      }
    });
  }
  /* 切换显示模式 */
  switchShowModel() {
    this.showTextModel = this.showTextModel == "day" ? "night" : "day";
  }
  //最近一次 scrolll top 值
  lastScrollTop: number = 0;
  onScroll($event) {
    this.showToolBar = this.lastScrollTop < $event.srcElement.scrollTop
    this.lastScrollTop = $event.srcElement.scrollTop;
  }
  /* 退出播放器 */
  exitAudio() {
    this.saveUserAudioProcess(this.audioObj.currentTime, () => {
      let link = ['survey', this.learningPathOrLearningTourId, this.surveyMetaId, this.method];
      this.router.navigate(link);
    });
  }

  closeDialog() {
    this.showTipEnable = false;
  }
  showDialog() {
    this.showTipEnable = true;
  }
  /*读取报告*/
  getReport() {
    let report = {"id":33588,"survey_id":37412,"emotionality":51,"emotionality_description":"\u2022 \u901a\u5e38\u4f60\u90fd\u5e73\u548c\u51b7\u9759\uff0c\u4f46\u91cd\u8981\u7684\u4e8b\u60c5\u4e5f\u4f1a\u8ba9\u4f60\u4ea7\u751f\u7d27\u5f20\u60c5\u7eea\uff0c\u4ece\u800c\u63d0\u524d\u89c4\u5212\uff0c\u671f\u671b\u5c3d\u5feb\u786e\u5b9a\u3002","delightful":74,"delightful_description":"\u2022 \u5584\u89e3\u4eba\u610f\u7684\u4f60\u4e0d\u7ba1\u662f\u5728\u8f85\u5bfc\u4e0b\u5c5e\u3001\u4e0e\u4eba\u5408\u4f5c\u3001\u8fd8\u662f\u5f71\u54cd\u4ed6\u4eba\u65f6\uff0c\u90fd\u66f4\u5bb9\u6613\u6362\u4f4d\u601d\u8003\uff0c\u4ece\u800c\u62c9\u8fd1\u8ddd\u79bb\u3002<br\/>\n\u2022 \u53ef\u80fd\u4e5f\u4f1a\u56e0\u4e3a\u671f\u671b\u505a\u51fa\u4eba\u4eba\u90fd\u6ee1\u610f\u7684\u51b3\u7b56\u800c\u4f18\u67d4\u5be1\u65ad\uff01","extroversion":51,"extroversion_description":"\u2022 \u4f60\u867d\u6ca1\u90a3\u4e48\u70ed\u8877\u793e\u4ea4\uff0c\u4f46\u5f53\u5de5\u4f5c\u548c\u76ee\u6807\u9700\u8981\u65f6\uff0c\u4ecd\u613f\u610f\u4e3b\u52a8\u4ea4\u6d41\u4fe1\u606f\uff0c\u5f71\u54cd\u4ed6\u4eba\uff0c\u4fc3\u8fdb\u5408\u4f5c\uff0c\u4ece\u800c\u63a8\u8fdb\u76ee\u6807\u8fbe\u6210\u3002","responsibility":53,"responsibility_description":"\u2022 \u4f60\u66f4\u613f\u5728\u5df2\u660e\u786e\u7684\u6388\u6743\u8303\u56f4\u5185\u8fdb\u884c\u6743\u8d23\u4e0b\u653e\uff0c\u5426\u5219\u4f1a\u62c5\u5fc3\u4e0b\u5c5e\u662f\u5426\u80dc\u4efb\uff0c\u4e0b\u653e\u7684\u51b3\u7b56\u6743\u662f\u5426\u5408\u7406\uff0c\u4ece\u800c\u5f71\u54cd\u8f85\u5bfc\u548c\u6388\u6743\u7684\u6548\u679c\u3002<br\/>\n\u2022 \u5728\u5c1a\u672a\u627e\u5230\u7b54\u6848\u4e4b\u524d\uff0c\u4f60\u4f1a\u5c1d\u8bd5\u4e0d\u540c\u65b9\u6cd5\uff0c\u4e00\u65e6\u786e\u5b9a\u540e\uff0c\u4f1a\u9075\u5b88\u5fc3\u4e2d\u6807\u51c6\u4e0e\u8ba1\u5212\uff0c\u6709\u6761\u7406\u5730\u5f00\u5c55\u5de5\u4f5c\u3002","open":97,"open_description":"\u2022 \u5bf9\u65b0\u4e8b\u7269\u7684\u597d\u5947\u5fc3\u4e0e\u5173\u6ce8\uff0c\u53ef\u80fd\u4f1a\u6fc0\u53d1\u65e0\u9650\u521b\u610f\uff1b\u4f46\u4e5f\u53ef\u80fd\u4f1a\u8ba9\u4f60\u5728\u65e5\u5e38\u6267\u884c\u4e2d\u4e0d\u65f6\u8df3\u620f\uff0c\u7ec6\u8282\u7f3a\u5e2d\u54e6\uff01","coaching":0,"coaching_description":null,"coaching_development":null,"guiding":0,"guiding_description":null,"guiding_development":null,"created_time":"2019-11-28 17:47:54","updated_time":"2019-11-28 17:47:54","details":[{"id":57089,"report_id":33588,"user_id":103088,"learning_tour_id":13980,"survey_type":1,"ability_id":1,"raw_point":36,"norm_point":74,"level":null,"grade":"H","description":"\u2022 \u5584\u89e3\u4eba\u610f\u7684\u4f60\u4e0d\u7ba1\u662f\u5728\u8f85\u5bfc\u4e0b\u5c5e\u3001\u4e0e\u4eba\u5408\u4f5c\u3001\u8fd8\u662f\u5f71\u54cd\u4ed6\u4eba\u65f6\uff0c\u90fd\u66f4\u5bb9\u6613\u6362\u4f4d\u601d\u8003\uff0c\u4ece\u800c\u62c9\u8fd1\u8ddd\u79bb\u3002<br\/>\n\u2022 \u53ef\u80fd\u4e5f\u4f1a\u56e0\u4e3a\u671f\u671b\u505a\u51fa\u4eba\u4eba\u90fd\u6ee1\u610f\u7684\u51b3\u7b56\u800c\u4f18\u67d4\u5be1\u65ad\uff01","development":"","created_time":"2019-11-28 17:47:54","updated_time":"2019-11-28 17:47:54","name":"\u4eb2\u548c","explanation":"\u613f\u610f\u5173\u5fc3\u5e76\u7406\u89e3\u4ed6\u4eba\u611f\u53d7\u7684\u503e\u5411\u3002","low_level_explanation":"\u503e\u5411\u76f4\u6307\u95ee\u9898\u75c7\u7ed3\uff0c\u8f83\u5c11\u5728\u610f\u4ed6\u4eba\u611f\u53d7\uff1b<br\/>\u91cd\u89c6\u6548\u7387\u548c\u95ee\u9898\u89e3\u51b3\uff1b<br\/>\u4eab\u53d7\u72ec\u7acb\u5de5\u4f5c\u3002","high_level_explanation":"\u5584\u4e8e\u89c9\u5bdf\u3001\u89e3\u8bfb\u4ed6\u4eba\u60c5\u7eea\uff1b<br\/>\u5e0c\u671b\u505a\u51fa\u5927\u591a\u6570\u4eba\u8ba4\u53ef\u7684\u51b3\u7b56\uff1b<br\/>\u91cd\u89c6\u56e2\u961f\u5408\u4f5c\u3002"},{"id":57090,"report_id":33588,"user_id":103088,"learning_tour_id":13980,"survey_type":1,"ability_id":2,"raw_point":39,"norm_point":53,"level":null,"grade":"M","description":"\u2022 \u4f60\u66f4\u613f\u5728\u5df2\u660e\u786e\u7684\u6388\u6743\u8303\u56f4\u5185\u8fdb\u884c\u6743\u8d23\u4e0b\u653e\uff0c\u5426\u5219\u4f1a\u62c5\u5fc3\u4e0b\u5c5e\u662f\u5426\u80dc\u4efb\uff0c\u4e0b\u653e\u7684\u51b3\u7b56\u6743\u662f\u5426\u5408\u7406\uff0c\u4ece\u800c\u5f71\u54cd\u8f85\u5bfc\u548c\u6388\u6743\u7684\u6548\u679c\u3002<br\/>\n\u2022 \u5728\u5c1a\u672a\u627e\u5230\u7b54\u6848\u4e4b\u524d\uff0c\u4f60\u4f1a\u5c1d\u8bd5\u4e0d\u540c\u65b9\u6cd5\uff0c\u4e00\u65e6\u786e\u5b9a\u540e\uff0c\u4f1a\u9075\u5b88\u5fc3\u4e2d\u6807\u51c6\u4e0e\u8ba1\u5212\uff0c\u6709\u6761\u7406\u5730\u5f00\u5c55\u5de5\u4f5c\u3002","development":"","created_time":"2019-11-28 17:47:55","updated_time":"2019-11-28 17:47:55","name":"\u4e25\u8c28","explanation":"\u613f\u610f\u9075\u5b88\u89c4\u8303\uff0c\u4e3a\u8fbe\u6210\u76ee\u6807\u800c\u52aa\u529b\u7684\u7a0b\u5ea6\u3002","low_level_explanation":"\u89c6\u53d8\u5316\u548c\u4e0d\u786e\u5b9a\u4e3a\u673a\u9047\uff1b<br\/>\u64c5\u957f\u7075\u6d3b\u8fd0\u7528\u89c4\u5219\uff1b<br\/>\u4e50\u4e8e\u6311\u6218\u89c4\u5219\uff0c\u968f\u65f6\u8c03\u6574\u8ba1\u5212\u3002","high_level_explanation":"\u613f\u610f\u6309\u89c4\u5219\u884c\u4e8b\uff1b<br\/>\u9700\u8981\u6e05\u6670\u7684\u804c\u8d23\u5206\u5de5\uff1b<br\/>\u6709\u5f88\u5f3a\u7684\u8ba1\u5212\u6027\u548c\u81ea\u6211\u7ea6\u675f\u529b\uff1b<br\/>\u7aed\u5c3d\u6240\u80fd\u5730\u5b9e\u73b0\u65e2\u5b9a\u76ee\u6807\u3002"},{"id":57091,"report_id":33588,"user_id":103088,"learning_tour_id":13980,"survey_type":1,"ability_id":3,"raw_point":49,"norm_point":51,"level":null,"grade":"M","description":"\u2022 \u4f60\u867d\u6ca1\u90a3\u4e48\u70ed\u8877\u793e\u4ea4\uff0c\u4f46\u5f53\u5de5\u4f5c\u548c\u76ee\u6807\u9700\u8981\u65f6\uff0c\u4ecd\u613f\u610f\u4e3b\u52a8\u4ea4\u6d41\u4fe1\u606f\uff0c\u5f71\u54cd\u4ed6\u4eba\uff0c\u4fc3\u8fdb\u5408\u4f5c\uff0c\u4ece\u800c\u63a8\u8fdb\u76ee\u6807\u8fbe\u6210\u3002","development":"","created_time":"2019-11-28 17:47:55","updated_time":"2019-11-28 17:47:55","name":"\u5916\u5411","explanation":"\u5bf9\u4eba\u9645\u4e92\u52a8\u548c\u793e\u4f1a\u8ba4\u540c\u7684\u9700\u6c42\u7a0b\u5ea6\u3002","low_level_explanation":"\u6c89\u9ed8\u5c11\u8a00\uff0c\u4ea4\u53cb\u91cd\u8d28\u4e0d\u91cd\u91cf\uff1b<br\/>\u884c\u4e3a\u7684\u4e3b\u8981\u52a8\u529b\u6765\u6e90\u4e8e\u81ea\u6211\u8ba4\u53ef\uff1b<br\/>\u9886\u5bfc\u4ed6\u4eba\u7684\u610f\u613f\u8f83\u5f31\u3002","high_level_explanation":"\u5584\u4e8e\u4ea4\u9645\u548c\u6784\u5efa\u4eba\u9645\u7f51\u7edc\uff1b<br\/>\u884c\u4e3a\u7684\u4e3b\u8981\u52a8\u529b\u6765\u6e90\u4e8e\u4ed6\u4eba\u7684\u8ba4\u53ef\u548c\u5173\u6ce8\uff1b<br\/>\u6bd4\u8d77\u505a\u8ffd\u968f\u8005\uff0c\u66f4\u5e0c\u671b\u9886\u5bfc\u4ed6\u4eba\u3002"},{"id":57092,"report_id":33588,"user_id":103088,"learning_tour_id":13980,"survey_type":1,"ability_id":4,"raw_point":29,"norm_point":51,"level":null,"grade":"M","description":"\u2022 \u901a\u5e38\u4f60\u90fd\u5e73\u548c\u51b7\u9759\uff0c\u4f46\u91cd\u8981\u7684\u4e8b\u60c5\u4e5f\u4f1a\u8ba9\u4f60\u4ea7\u751f\u7d27\u5f20\u60c5\u7eea\uff0c\u4ece\u800c\u63d0\u524d\u89c4\u5212\uff0c\u671f\u671b\u5c3d\u5feb\u786e\u5b9a\u3002","development":"","created_time":"2019-11-28 17:47:55","updated_time":"2019-11-28 17:47:55","name":"\u60c5\u7eea\u7a33\u5b9a","explanation":"\u5bf9\u60c5\u7eea\u7684\u4f53\u9a8c\u548c\u60c5\u611f\u8c03\u8282\u7684\u6c34\u5e73\u3002","low_level_explanation":"\u60c5\u7eea\u8d77\u4f0f\u8f83\u5927\uff0c\u884c\u4e3a\u6613\u53d7\u60c5\u7eea\u5f71\u54cd\uff1b<br\/>\u9700\u8981\u4ed6\u4eba\u65f6\u5e38\u652f\u6301\u9f13\u52b1\uff1b<br\/>\u65f6\u6709\u7126\u8651\u4e0e\u7d27\u8feb\u611f\u3002","high_level_explanation":"\u5584\u4e8e\u8c03\u8282\u60c5\u7eea\uff0c\u884c\u4e3a\u4e0d\u6613\u53d7\u60c5\u7eea\u5f71\u54cd\uff1b<br\/>\u9ad8\u538b\u4e0b\uff0c\u4ecd\u80fd\u4fdd\u6301\u9ad8\u6548\u884c\u4e8b\uff1b<br\/>\u8f83\u5c11\u611f\u89c9\u7126\u8651\u548c\u7d27\u8feb\u3002"},{"id":57093,"report_id":33588,"user_id":103088,"learning_tour_id":13980,"survey_type":1,"ability_id":5,"raw_point":62,"norm_point":97,"level":null,"grade":"H","description":"\u2022 \u5bf9\u65b0\u4e8b\u7269\u7684\u597d\u5947\u5fc3\u4e0e\u5173\u6ce8\uff0c\u53ef\u80fd\u4f1a\u6fc0\u53d1\u65e0\u9650\u521b\u610f\uff1b\u4f46\u4e5f\u53ef\u80fd\u4f1a\u8ba9\u4f60\u5728\u65e5\u5e38\u6267\u884c\u4e2d\u4e0d\u65f6\u8df3\u620f\uff0c\u7ec6\u8282\u7f3a\u5e2d\u54e6\uff01","development":"","created_time":"2019-11-28 17:47:55","updated_time":"2019-11-28 17:47:55","name":"\u5f00\u653e","explanation":"\u5bf9\u65b0\u4e8b\u7269\u7684\u6001\u5ea6\u503e\u5411\u3002","low_level_explanation":"\u66f4\u613f\u63a5\u53d7\u719f\u6089\u7684\u4e8b\u7269\uff1b<br\/>\u4e60\u60ef\u91c7\u7528\u65e2\u6709\u7684\u5de5\u4f5c\u65b9\u5f0f\uff1b<br\/>\u5173\u6ce8\u5f53\u4e0b\u7684\u6267\u884c\u548c\u7ec6\u8282\u3002\n","high_level_explanation":"\u4e3b\u52a8\u5173\u6ce8\u65b0\u4e8b\u7269\u3001\u65b0\u8d8b\u52bf\uff1b<br\/>\u6e34\u671b\u5b66\u4e60\u65b0\u4e1c\u897f\uff1b<br\/>\u5173\u6ce8\u672a\u6765\u7684\u53ef\u80fd\u6027\u3002"}],"delightful_development":"","responsibility_development":"","extroversion_development":"","emotionality_development":"","open_development":""};
    this.report = this.resortReportItem(report.details);
  }
  //兼容显示须序
  resortReportItem(reportItems){
    var newReports = [];
    var nextSort = ["外向","亲和","开放","严谨","情绪稳定"];
    nextSort.forEach((item)=>{
      reportItems.forEach((subItem)=>{
        if(item == subItem.name){
          newReports.push(subItem);
        }
      });
    });
    return newReports;
  }

  //是否touch
  touchEnable: boolean = false;
  touchEnableContent: boolean = false;
  touchX: number = 0;
  touchY: number = 0;
  moveTouchTimes = 0;
  currentProcessWidth: number = 0;
  currentProcessBarWidth: number = 0;
  touchstart($event) {
    this.touchEnable = true;
    this.touchX = $event.touches[0].clientX;
    this.currentProcessWidth = $(this.el.nativeElement.querySelector(".audioPlay-play-wrap")).width();
    this.currentProcessBarWidth = $(this.el.nativeElement.querySelector(".audioPlay-play")).width();
  }
  touchstartContent($event) {
    this.touchEnableContent = true;
    this.touchY = $event.touches[0].clientY;
  }
  touchmove($event) {
    if(this.touchEnable) {
      let moveX = $event.touches[0].clientX - this.touchX;
      let currentaudio = this.audioObj;
      if(!currentaudio.duration) {
        return false;
      }
      let audioAllTime = currentaudio.duration;
      let moveValue = this.currentProcessBarWidth + moveX;
      if(moveValue >= 0 && moveValue <= this.currentProcessWidth) {
        this.moveTouchTimes = audioAllTime * ((this.currentProcessBarWidth + moveX) / this.currentProcessWidth);
        this.updateProcessUI(this.moveTouchTimes, audioAllTime);
      }

    }

    if(this.touchEnableContent) {
      let moveY = $event.touches[0].clientY - this.touchY;
      this.showToolBar = moveY <= 0;
    }
  }
  touchend() {
    this.touchEnable = false;
    this.touchEnableContent = false;
    if(this.moveTouchTimes != 0) {
      this.audioObj.currentTime = this.moveTouchTimes;
      this.moveTouchTimes = 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app-audio-play-base/app-audio-play-base.component.ts